<template>
  <v-dialog v-model="dialogModel" max-width="550">
    <v-card>
      <v-card-text>
        <VueCtkDateTimePicker
          v-model="value"
          v-validate="'required'"
          no-clear-button
          name="start_at"
          inline
        />
      </v-card-text>
      <v-card-actions>
        <v-btn text color="secondary" @click="dialogModel = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'DatePicker',
  props: [
    'dialog',
    'datePickerType',
    'toggleDatePickerDialog',
    'saveDatePicker',
    'startDate',
    'endDate',
  ],
  computed: {
    dialogModel: {
      get() {
        return this.dialog;
      },
      set() {
        this.toggleDatePickerDialog();
      },
    },
    value: {
      get() {
        if (this[this.datePickerType] === undefined) {
          return;
        }

        let date = new Date(this[this.datePickerType].$d);

        return dayjs(date).format('YYYY-MM-DD HH:mm');
      },
      set(value) {
        this.saveDatePicker(value);
      },
    },
  },
};
</script>

<style scoped></style>
